/**
 * useSolflareCampaign Hook
 *
 * Fetches and manages Solflare wallet campaign status.
 * Returns campaign details including:
 * - Whether campaign is active
 * - User's bonus points earned
 * - Remaining bonus available
 * - Campaign dates
 */

import { useQuery } from '@tanstack/react-query';

import { getSolflareCampaignStatus } from '@/api/auth';
import config from '@/config';

export function useSolflareCampaign() {
  const query = useQuery({
    queryKey: ['solflareCampaign'],
    queryFn: async () => {
      const response = await getSolflareCampaignStatus();
      if (response.code !== 0) {
        throw new Error(response.message || 'Failed to fetch campaign status');
      }
      return response.data;
    },
    enabled: config.ENABLE_SOLFLARE_CAMPAIGN, // Only fetch if feature flag is enabled
    staleTime: 30 * 1000, // Cache for 30 seconds
    refetchInterval: 60 * 1000, // Refetch every 60 seconds to keep countdown updated
  });

  return {
    campaignData: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
